import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';

function useCurrentOrganizationName(): string | null {
	const context = useCurrentOrganization();

	return context.currentOrganization?.name ?? null;
}

export default useCurrentOrganizationName;
